module.exports = __webpack_public_path__ + "static/media/steel_1.f42c15b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/textures/steel_1.jpg
// module id = 1127
// module chunks = 0